<template>
  <div>
    <b-container class="bg-white py-2 my-4 container-tasks">
      <b-row class="py-2" @click="">
        <b-col cols="8">
          <label class="font-weight-bold">{{
            new Date().toLocaleDateString('en-us', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })
          }}</label>
        </b-col>
        <b-col cols="4" class="text-right">
          <span class="calendarFont text-link pr-2 font-weight-bold text-secondary"
            >See calendar</span
          >
        </b-col>
      </b-row>
      <span v-if="haveTask">
        <div
          v-for="(task, idx) in tasks"
          v-bind:key="idx"
          class="d-flex mb-1 py-1 align-items-center"
        >
          <div v-if="!isCompleteTask(task)" class="d-flex mb-1 py-1 align-items-center w-100">
            <input
              :id="task.id"
              type="checkbox"
              class="atm-input text-muted"
              v-model="checkedFilters"
              :value="task.id"
              :disabled="isCompleteTask(task) || task.state == 1"
              @change="tryMarkAsComplete($event, task)"
            />
            <label :for="task.id" class=" material-icons-round d-flex "></label>
            <b-modal id="modal-1" title="BootstrapVue">
              <p class="my-4">Hello from modal!</p>
            </b-modal>
            <div
              class="task-container"
              :style="task.subjectColor ? `background-color: #${task.subjectColor}` : ``"
            >
              <span class="w-100" :class="task.subjectColor ? 'text-light' : 'text-dark'">{{
                task.title
              }}</span>
              <span
                v-if="task.description"
                class="taskDescription w-100"
                :class="
                  task.priority.description.toLowerCase() != 'none' ? 'text-light' : 'text-dark'
                "
                >{{ task.description }}</span
              >
            </div>
          </div>
        </div>
      </span>
      <span v-else>
        <b-row class="mb-1 p-4 align-items-center">
          <b-col cols="9">
            <small class="text-muted" v-html="textDonTHaveAnyTasksYet"></small>
          </b-col>
          <b-col cols="3" class="text-right">
            <span
              class="material-icons bg-warning rounded-circle align-middle text-light big-icon cursor"
              @click.stop="goToCalendar"
              >add</span
            >
          </b-col>
        </b-row>
      </span>
    </b-container>
  </div>
</template>

<script>
import { modalsMixin } from '@/common/mixins';
import { updateStatusToTask } from '@/tasks';
import { useSessionStore } from '@/common';
import notificationToastMixin from '@/Mixins/notificationToast.mixin';

export default {
  mixins: [modalsMixin, notificationToastMixin],
  data: function() {
    const sessionStore = useSessionStore();
    return {
      completeClass: {
        color: '#DC3545',
      },
      value: true,
      checkedFilters: [],
      originalChecked: [],
      sessionStore,
    };
  },
  props: {
    tasks: Array,
    haveTask: Boolean,
  },
  computed: {
    userIsAParent() {
      return this.sessionStore.userIsAParent;
    },
    childName() {
      if (this.userIsAParent) return this.sessionStore.childName;
      return 'You';
    },
    textDonTHaveAnyTasksYet() {
      return `${this.childName} don't have any <strong>tasks</strong> yet.`;
    },
    parentCanEdit() {
      return this.sessionStore.getCurrentChild.parentCanEdit;
    },
  },
  methods: {
    async tryMarkAsComplete(event, task) {
      if (event.target.checked) {
        if (this.userIsAParent && !this.parentCanEdit) {
          this.readOnlyUserNotificationToast();
          return;
        }
        const value = await this.confirmationModal('Did you already finish this task?');
        if (value) {
          const response = await updateStatusToTask(task.id);
          this.originalChecked.push(task.id);
          this.$router.push({
            name: 'congrats',
            params: {
              coins: response.coins,
              points: response.points,
              description: response.description,
            },
            query: { next: '/' },
          });
        } else {
          this.checkedFilters = this.originalChecked;
        }
      }
    },
    isCompleteTask(task) {
      if (this.originalChecked.includes(task.id)) {
        return true;
      }
      return task.state >= 4;
    },
    created() {
      this.tasks.forEach((element) => {
        if (element.state >= 4) {
          this.checkedFilters.push(element.id);
          this.originalChecked.push(element.id);
        }
      });
    },
    goToCalendar() {
      this.$router.push({ name: 'calendar' });
    },
  },
};
</script>

<style lang="scss" scoped>
.container-tasks {
  border-radius: 10px;
  box-shadow: 0px 1px 9px 2px #0000001c;
  width: 100%;
}

input[type='checkbox']:checked + label {
  background-color: var(--color-low);
  color: white;
}

.task-container {
  height: 60px;
  display: flex;
  flex-wrap: wrap;
  background-color: #e0e0e0;
  flex-grow: 1;
  border-radius: 12px;
  padding: 8px 0px !important;
  padding-left: 15px !important;
}

.taskDescription {
  font-size: 12px;
}

.calendarFont {
  font-size: 14px;
}
</style>
